import React, { useState } from 'react';
import styled from 'styled-components';

const TopbarContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 30px;
  background: #222;
  color: white;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
  font-family: 'Segoe UI', sans-serif;
`;

const Logo = styled.div`
  font-size: 1.4rem;
  font-weight: 600;
  cursor: pointer;

  @media (max-width: 768px) {
    font-size: 1.2rem;
  }
`;

const Menu = styled.div`
  display: flex;
  gap: 25px;

  @media (max-width: 768px) {
    display: ${(props) => (props.isOpen ? 'flex' : 'none')};
    flex-direction: column;
    position: absolute;
    top: 60px;
    right: 20px;
    background: #222;
    padding: 15px;
    border-radius: 8px;
  }
`;

const MenuItem = styled.a`
  text-decoration: none;
  color: white;
  font-size: 1rem;
  cursor: pointer;
  font-weight: 500;

  &:hover {
    color: #00c0ff;
  }

  @media (max-width: 768px) {
    font-size: 0.95rem;
  }
`;

const HamburgerMenu = styled.div`
  display: none;
  flex-direction: column;
  cursor: pointer;

  @media (max-width: 768px) {
    display: flex;
  }
`;

const Bar = styled.div`
  width: 25px;
  height: 3px;
  background-color: white;
  margin: 3px 0;
`;

const Topbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  const handleMenuToggle = () => setIsOpen(!isOpen);

  const scrollToSection = (id) => {
    const section = document.getElementById(id);
    if (section) {
      section.scrollIntoView({ behavior: 'smooth' });
      setIsOpen(false);
    }
  };

  return (
    <TopbarContainer>
      <Logo onClick={() => scrollToSection('home')}>Portfolio</Logo>
      <HamburgerMenu onClick={handleMenuToggle}>
        <Bar />
        <Bar />
        <Bar />
      </HamburgerMenu>
      <Menu isOpen={isOpen}>
        <MenuItem onClick={() => scrollToSection('about')}>About</MenuItem>
        <MenuItem onClick={() => scrollToSection('skills')}>Skills</MenuItem>
        <MenuItem onClick={() => scrollToSection('projects')}>Projects</MenuItem>
        <MenuItem onClick={() => scrollToSection('contact')}>Contact</MenuItem>
      </Menu>
    </TopbarContainer>
  );
};

export default Topbar;
